import axios from "axios"
import { notification } from 'ant-design-vue'
const baseURL = "http://shsn.innomesh.cn:8012/"
// const baseURL = "http://192.168.10.93:8812/"
const service = axios.create({
    baseURL,
    timeout: 10000 // request timeout
})
import Cookies from 'js-cookie'
import router from "@/router"
// 发起请求之前的拦截器
service.interceptors.request.use(
    config => {
        // 如果有token 就携带tokon
        // const token = window.localStorage.getItem("accessToken")
        const token = Cookies.get('Token')
        if (token) {
            // config.headers.common.Authorization = 'Basic '+JSON.parse(token)
            config.headers.common.token = 'Bearer ' + JSON.parse(token)
        }
        //临时token等
        // config.headers.common.Authorization = 'Basic enVpaG91X3VpOnp1aWhvdV91aV9zZWNyZXQ='
        config.headers.common.tenant = 'MDAwMA=='
        // config.headers.common.token = 'Bearer test'
        return config
    },
    error => Promise.reject(error)
);
// 响应拦截器
let responseStatus = true
service.interceptors.response.use(
    response => {
        const status = JSON.parse(response.request.response)
        if (!status.isSuccess) {
            notification.error({ message: '错误!', description: status.msg, duration: 5 })
        }
        const res = response.data
        if (response.status != 200) {
            notification.error({ message: '错误!', description: response.data.msg, duration: 5 })
            // return Promise.reject(new Error(res.message || "Error"))
            return res.data
        } else {
            return res.data
        }
    },
    error => {
        console.log("err" + error) // for debug
        if (error.response.status === 401 || error.response.status === 400) {
            if (responseStatus) {
                responseStatus = false
                notification.warning({ message: '操作需要登录，将跳转到登录页面!', description: '', duration: 2 })
                if (error.response.config.url.split('/')[1] === 'enterpriseClassify') {
                    router.push({ name: 'adminLogin'})
                    return
                }
                const sw = window.screen.width
                setTimeout(() => {
                    if (sw < 700) {
                        router.push({ name: 'Login'})
                    } else {
                        router.push({ name: '/LoginPage'})
                    }
                }, 2000)
            }
        }
        return Promise.reject(error)
    }
);
export default service
